












import React, { useState } from "react";
import "../styles/Career.css";

// Import your icon and image
import shipWheelIcon from "../assets/icons/ship-wheel-icon.png";
import careerImage from "../image/Career-image.png"; // Make sure this path is correct

const Career = () => {
  const [formData, setFormData] = useState({
    name: "",
    contactNumber: "",
    email: "",
    currentLocation: "",
    specialization: "",
    description: "",
    resume: null
  });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" }); // "success" or "error"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFileChange = (e) => {
    // Store the file in the form data state
    setFormData({
      ...formData,
      resume: e.target.files[0]
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage({ text: "", type: "" });
    
    // Check if file is selected
    if (!formData.resume) {
      setMessage({ 
        text: "Please select a resume file to upload", 
        type: "error" 
      });
      setSubmitting(false);
      return;
    }
    
    const data = new FormData();
    
    // Add all form fields to FormData
    Object.keys(formData).forEach((key) => {
      if (key === 'resume') {
        if (formData[key]) {
          // Use "resume" as the key to match backend expectation
          data.append('resume', formData[key], formData[key].name);
        }
      } else {
        data.append(key, formData[key]);
      }
    });
    
    // Log FormData contents for debugging (can't directly console.log FormData)
    console.log("Submitting form data:");
    for (let pair of data.entries()) {
      console.log(pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name : pair[1]));
    }

    try {
      // Updated URL to match the FastAPI endpoint
      const response = await fetch("https://ecl.net.in/backende/api/careers", {
        method: "POST",
        body: data,
        // Don't set Content-Type header when using FormData
      });

      const result = await response.json();

      if (result.success) {
        setMessage({ 
          text: "Application submitted successfully! We'll get back to you soon.", 
          type: "success" 
        });
        handleReset();
      } else {
        setMessage({ 
          text: "Failed to submit application: " + (result.message || "Please try again."), 
          type: "error" 
        });
      }
    } catch (error) {
      console.error("Error submitting application:", error);
      setMessage({ 
        text: "Error connecting to server. Please try again later.", 
        type: "error" 
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      contactNumber: "",
      email: "",
      currentLocation: "",
      specialization: "",
      description: "",
      resume: null
    });
    // Reset the file input by clearing its value
    const fileInput = document.getElementById("resumeFile");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  return (
    <div className="career-container">
      {/* Image Slider */}
      <div className="career-image-slider">
        <img src={careerImage} alt="Career Opportunities" />
      </div>
      
      <div className="career-content">
        <div className="career-form-card">
          <div className="career-header">
            <img src={shipWheelIcon} alt="Ship Wheel" className="career-wheel-icon" />
            <h2 className="career-title">Resume Upload</h2>
          </div>
          
          {message.text && (
            <div className={`career-message ${message.type === "success" ? "career-success" : "career-error"}`}>
              {message.text}
            </div>
          )}
          
          <div className="career-form-content">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="career-form-row">
                <label htmlFor="name">Name :</label>
                <div className="career-input-container">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    disabled={submitting}
                  />
                </div>
              </div>

              <div className="career-form-row">
                <label htmlFor="contactNumber">Contact Number :</label>
                <div className="career-input-container">
                  <input
                    type="tel"
                    id="contactNumber"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    required
                    disabled={submitting}
                  />
                </div>
              </div>

              <div className="career-form-row">
                <label htmlFor="email">Email :</label>
                <div className="career-input-container">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={submitting}
                  />
                </div>
              </div>

              <div className="career-form-row">
                <label htmlFor="currentLocation">Current Location :</label>
                <div className="career-input-container">
                  <input
                    type="text"
                    id="currentLocation"
                    name="currentLocation"
                    value={formData.currentLocation}
                    onChange={handleChange}
                    required
                    disabled={submitting}
                  />
                </div>
              </div>

              <div className="career-form-row">
                <label htmlFor="specialization">Specialization :</label>
                <div className="career-input-container">
                  <input
                    type="text"
                    id="specialization"
                    name="specialization"
                    value={formData.specialization}
                    onChange={handleChange}
                    required
                    disabled={submitting}
                  />
                </div>
              </div>

              <div className="career-form-row">
                <label htmlFor="description">Description :</label>
                <div className="career-input-container">
                  <textarea
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    rows="5"
                    disabled={submitting}
                  ></textarea>
                </div>
              </div>

              <div className="career-form-row">
                <label htmlFor="resumeFile">Upload Resume :</label>
                <div className="career-input-container">
                  <input
                    type="file"
                    id="resumeFile"
                    name="resumeFile"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                    required
                    className="career-file-input"
                    disabled={submitting}
                  />
                  <small className="form-text text-muted">
                    Accepted formats: PDF, DOC, DOCX (Max size: 5MB)
                  </small>
                </div>
              </div>

              <div className="career-button-container">
                <button 
                  type="submit" 
                  className="career-send-btn"
                  disabled={submitting}
                >
                  {submitting ? "Submitting..." : "Send"}
                </button>
                <button 
                  type="button" 
                  className="career-reset-btn" 
                  onClick={handleReset}
                  disabled={submitting}
                >
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Career;
